// (live-test pass 4): the ONE 8-digit magic-code input. Shared by
// the login screen (AuthScreen) and the impersonation picker — same look,
// same behaviour, one component. Numeric-only, big tracking display,
// Enter-to-submit.

export const CodeInput = ({
  value,
  onChange,
  onSubmit,
  disabled = false,
  autoFocus = true,
}: {
  value: string;
  onChange: (v: string) => void;
  onSubmit?: () => void;
  disabled?: boolean;
  autoFocus?: boolean;
}) => (
  <input
    type="text"
    inputMode="numeric"
    pattern="[0-9]*"
    autoComplete="one-time-code"
    value={value}
    onChange={(e) => onChange(e.target.value.replace(/[^\d]/g, '').slice(0, 8))}
    onKeyDown={(e) => {
      if (e.key === 'Enter' && onSubmit) {
        e.preventDefault();
        onSubmit();
      }
    }}
    // An eight-zero placeholder reads as a filled field at this
    // size and weight. Dashes read as eight empty slots, and the muted
    // placeholder colour keeps them clearly distinct from typed digits.
    placeholder="--------"
    aria-label="קוד אימות בן 8 ספרות"
    dir="ltr"
    disabled={disabled}
    autoFocus={autoFocus}
    className="w-full rounded-lg border border-[var(--color-border)] bg-[var(--color-surface)] px-3 py-3 text-center font-mono text-2xl font-bold tracking-[0.4em] tabular-nums outline-none placeholder:font-normal placeholder:text-[var(--color-border)] focus:border-[var(--color-primary)] disabled:opacity-50"
  />
);

// True when the string is a complete 8-digit code — the shared submit gate.
export const isCompleteCode = (code: string): boolean => /^[0-9]{8}$/.test(code);
